class ProductMedias extends HTMLElement {
  constructor() {
    super();
    this.swiperInit();
  }

  swiperInit() {
    var swiper = new Swiper(
      this.querySelector(".product-medias__thumbnail--main"),
      {
        slidesPerView: 4,
        spaceBetween: 16,
        direction: "horizontal",
        freeMode: true,
        allowTouchMove: true,
        watchSlidesVisibility: true,
        autoScrollOffset: 1,
        watchSlidesProgress: true,
        centerSliders: true,
        freeMode: false,
        loop: false,
simulateTouch: true,
  touchStartPreventDefault: false, 
        centeredSlidesBounds: true,
        navigation: {
          nextEl: this.querySelector(
            ".product-medias-thumb--main .product-medias__thumbnail .products-list-v2__next"
          ),
          prevEl: this.querySelector(
            ".product-medias-thumb--main .product-medias__thumbnail .products-list-v2__prev"
          ),
        },
        breakpoints: {
          990: {
            allowTouchMove: false,
            centerSliders: true,
            freeMode: false,
            centeredSlidesBounds: true,
            spaceBetween: 0,
            slidesPerView: 4,
            freeMode: false,
            centeredSlidesBounds: true,
            autoScrollOffset: 1,
            direction: "vertical",
            navigation: {
              nextEl: this.querySelector(
                ".product-medias-thumb--main .product-medias__thumbnail .products-list-v2__next"
              ),
              prevEl: this.querySelector(
                ".product-medias-thumb--main .product-medias__thumbnail .products-list-v2__prev"
              ),
            },
          },
        },
      }
    );

    var swiper2 = new Swiper(
      this.querySelector(".product-medias__main--main"),
      {
        loopPreventsSlide: false,
        allowTouchMove: true,
        preventClicks: false,
        touchStartPreventDefault: false,
        releaseOnEdges: true,
        allowTouchMove: true,
        loopPreventsSlide: false,
        preloadImages: false,
        loop: true,
        thumbs: {
          swiper: swiper,
          autoScrollOffset: 0,
          thumbsContainerClass: "thumbs-container",
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        breakpoints: {
          990: {
            allowTouchMove: false,
            effect: "fade",
            fadeEffect: {
              crossFade: true,
            },
          },
        },
      }
    );

    const wrapper = document.querySelector('.product-medias__thumbnail--main .swiper-wrapper');

  if (wrapper) {
    const slides = wrapper.querySelectorAll('.swiper-slide');
    if (slides.length > 0 && slides.length < 5) {
      wrapper.classList.add('center');
    }
  }
  }
}

customElements.define("product-medias", ProductMedias);

class ProductMediasModal extends HTMLElement {
  constructor() {
    super();
    this.swiperInit();
    document
      .querySelectorAll(".modal-product-medias__close")
      .forEach((button) => {
        button.addEventListener("click", this.closeModal.bind(this));
      });
    document.querySelectorAll(" .product__media-toggle").forEach((button) => {
      button.addEventListener("click", this.openModal.bind(this));
    });
    this.querySelectorAll(".product__media-toggle").forEach((item) => {
      item.addEventListener("click", this.closeModal.bind(this));
    });
  }

  openModal(e) {
    if (window.innerWidth > 989) {
      document.querySelector("body").classList.add("overflow-hidden");
      var image_index = e.target
        .closest(".product-medias__item")
        .getAttribute("data-image-index");
      this.swiper2.slideTo(image_index, 0, false);
      document
        .querySelector(".modal-product-medias")
        .classList.remove("hidden");
    }
  }

  closeModal() {
    document.querySelector("body").classList.remove("overflow-hidden");
    document.querySelector(".modal-product-medias").classList.add("hidden");
  }

  swiperInit() {
    this.swiper = new Swiper(".product-medias__thumbnail--modal", {
      slidesPerView: 4,
      spaceBetween: 16,
      direction: "horizontal",
      freeMode: true,
      allowTouchMove: true,
      watchSlidesVisibility: true,
      autoScrollOffset: 1,
      watchSlidesProgress: true,
      centerSliders: true,
      freeMode: false,
      centeredSlidesBounds: true,
      navigation: {
        nextEl: document.querySelector(
          ".product-medias-thumb--modal .product-medias__thumbnail  .products-list-v2__next"
        ),
        prevEl: document.querySelector(
          ".product-medias-thumb--modal .product-medias__thumbnail  .products-list-v2__prev"
        ),
      },
      breakpoints: {
        990: {
          allowTouchMove: false,
          centerSliders: true,
          freeMode: false,
          centeredSlidesBounds: true,
          spaceBetween: 0,
          slidesPerView: 4,
          freeMode: false,
          centeredSlidesBounds: true,
          autoScrollOffset: 1,
          direction: "vertical",
          navigation: {
            nextEl: document.querySelector(
              ".product-medias-thumb--modal .product-medias__thumbnail .products-list-v2__next"
            ),
            prevEl: document.querySelector(
              ".product-medias-thumb--modal .product-medias__thumbnail  .products-list-v2__prev"
            ),
          },
        },
      },
    });
    this.swiper2 = new Swiper(".product-medias__main--modal", {
      loopPreventsSlide: false,
      allowTouchMove: true,
      preventClicks: false,
      touchStartPreventDefault: false,
      releaseOnEdges: true,
      loopPreventsSlide: false,
      fadeEffect: {
        crossFade: true,
      },
      preloadImages: false,
      allowTouchMove: false,
      thumbs: {
        swiper: this.swiper,
        autoScrollOffset: 0,
        thumbsContainerClass: "thumbs-container",
      },
      breakpoints: {
        990: {
          allowTouchMove: false,
          fadeEffect: {
            crossFade: true,
          },
          effect: "fade",
        },
      },
    });
  }
}

customElements.define("product-medias-modal", ProductMediasModal);
